import { render, staticRenderFns } from "./incomeReleaseRecord.vue?vue&type=template&id=5fe3a4cf&scoped=true"
import script from "./incomeReleaseRecord.vue?vue&type=script&lang=js"
export * from "./incomeReleaseRecord.vue?vue&type=script&lang=js"
import style0 from "./incomeReleaseRecord.vue?vue&type=style&index=0&id=5fe3a4cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe3a4cf",
  null
  
)

export default component.exports